import { ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  HStack,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast
} from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import * as CarteiraRecomendadaService from '../../../services/previdencia-individual/carteira_recomendada.service';

export const CarteiraRecomendada = () => {
  const toast = useToast();
  const [pdfFiles, setPdfFiles] = useState([
    {
      id: 'carteira_arrojada_2025',
      checked: false,
      nome_arquivo: 'Carteira Arrojada',
      tamanho_arquivo: '314,3 KB',
      data_upload: '01/09/2025'
    },
    {
      id: 'carteira_conservadora_2025',
      checked: false,
      nome_arquivo: 'Carteira Conservadora',
      tamanho_arquivo: '311,2 KB',
      data_upload: '01/09/2025'
    },
    {
      id: 'carteira_moderada_2025',
      checked: false,
      nome_arquivo: 'Carteira Moderada',
      tamanho_arquivo: '313,8 KB',
      data_upload: '01/09/2025'
    }
  ]);
  const { mutate, isLoading } = useMutation({
    mutationFn: (files: any[]) =>
      CarteiraRecomendadaService.downloadFiles(files),
    onSuccess: (data) => {
      data.forEach((url, i) => {
        window.open(url, '_blank');
      });
    },
    onError: (error) => {
      toast({
        status: 'error',
        title: 'Ops! Ocorreu um erro ao fazer o download',
        description: 'Tente novamente mais tarde!',
        isClosable: true
      });
    }
  });
  const downloadSingleFile = (id: string) => {
    if (id === 'all') {
      mutate([{ id: 'all' }]);
      return;
    }
    const files = pdfFiles.filter((e) => e.id === id);
    mutate(files);
  };

  return (
    <Stack px={24} mt={10} spacing={6}>
      <Stack spacing={7}>
        <Stack spacing={2}>
          <Flex justifyContent="space-between" alignItems="center">
            <Text color="#00335E" fontWeight="bold" fontSize="2rem">
              Carteira Recomendada
            </Text>
          </Flex>
          <Text>
            Faça download do arquivo e indique o melhor fundo de investimento
            para seus clientes
          </Text>
        </Stack>
        <Link href="/corretor" w="4rem">
          <HStack spacing={0}>
            <ChevronLeftIcon color={'#001E64'} />
            <Text fontSize="1rem" color="#001E64" fontWeight="bold">
              Voltar
            </Text>
          </HStack>
        </Link>
      </Stack>
      <Divider borderColor={'#D2D2D2'} borderWidth={1.4} />
      <Stack
        w={'full'}
        bg="white"
        shadow={'md'}
        borderRadius={15}
        p={30}
        spacing={5}
      >
        <TableContainer w={'full'}>
          <Table
            fontSize={'0.875rem'}
            variant="unstyled"
            style={{ borderCollapse: 'separate', borderSpacing: '0 4px' }}
          >
            <Thead>
              <Tr>
                <Th>Arquivos</Th>
                <Th textAlign={'center'}>Data de upload</Th>
                <Th width={100} textAlign={'center'}>
                  Download
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {pdfFiles.map((pdf) => (
                <Tr bg="#F4F4F4" key={pdf.id} mb={2}>
                  <Td>
                    <HStack gap={2}>
                      <PDFIcon />
                      <Stack>
                        <Text fontWeight={'semibold'}>{pdf.nome_arquivo}</Text>
                        <Text>{pdf.tamanho_arquivo}</Text>
                      </Stack>
                    </HStack>
                  </Td>
                  <Td textAlign={'center'}>
                    <Text>{pdf.data_upload}</Text>
                  </Td>
                  <Td textAlign={'center'}>
                    <IconButton
                      aria-label="download"
                      icon={<DownloadIcon />}
                      variant="unstyled"
                      onClick={() => downloadSingleFile(pdf.id)}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
        <Box>
          <Button
            onClick={() => downloadSingleFile('all')}
            py={'1.5rem'}
            px={'2rem'}
            bg={'#FF5000'}
            rounded="full"
            _hover={{ bg: '#E04A05' }}
          >
            <Flex gap={2} alignItems="center">
              <DownloadOutlineIcon />
              <Text color={'white'} fontWeight={'semibold'}>
                Baixar todos
              </Text>
            </Flex>
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
};

const PDFIcon = () => (
  <svg
    width="35"
    height="42"
    viewBox="0 0 35 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.3636 42H2C0.895429 42 0 41.1046 0 40V2C0 0.89543 0.895431 0 2 0H24.8182L34.3636 9.54545V40C34.3636 41.1046 33.4682 42 32.3636 42Z"
      fill="#DB0202"
    />
    <path
      d="M24.8181 8.54545V0L34.3635 9.54545H25.8181C25.2658 9.54545 24.8181 9.09774 24.8181 8.54545Z"
      fill="#F7B9B9"
    />
    <path
      d="M8.30308 21H3.81805V30.5455H5.91901V27.4496H8.18388C10.4338 27.4496 11.9388 26.2457 11.9388 24.1675C11.9388 22.1179 10.6424 21 8.30308 21ZM9.79312 24.2105C9.77822 25.1421 9.1077 25.6437 8.00507 25.6437H5.91901V22.7916H8.00507C9.0928 22.7916 9.80802 23.2645 9.79312 24.2105Z"
      fill="white"
    />
    <path
      d="M17.1646 21H13.3352V30.5455H17.0901C20.249 30.5455 22.2308 28.6966 22.2308 25.7297C22.2308 22.7629 20.3235 21 17.1646 21ZM17.0007 28.7539L15.4511 28.7396V22.7772H16.956C18.908 22.7916 20.0106 23.8522 20.0106 25.8014C20.0106 27.7506 18.9229 28.7539 17.0007 28.7539Z"
      fill="white"
    />
    <path
      d="M30.5453 22.8632V21H23.855V30.5455H25.956V27.1057H30.1579V25.2568H25.956V22.8632H30.5453Z"
      fill="white"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="white" />
    <mask
      id="mask0_49_2182"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="7"
      width="26"
      height="26"
    >
      <rect x="7.5" y="7.5" width="25" height="25" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_49_2182)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5 17.3036H22.7857V11.5H17.2143V17.3036H13.5L20 24.0744L26.5 17.3036ZM19.0714 19.2381V13.4345H20.9286V19.2381H22.015L20 21.3371L17.985 19.2381H19.0714ZM26.5 27.9435V26.0089H13.5V27.9435H26.5Z"
        fill="#001E64"
      />
    </g>
  </svg>
);
//

const DownloadOutlineIcon = () => (
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 5.80357H9.28571V0H3.71429V5.80357H0L6.5 12.5744L13 5.80357ZM5.57142 7.7381V1.93453H7.42856V7.7381H8.51499L6.49999 9.83706L4.48499 7.7381H5.57142ZM13 16.4435V14.5089H0V16.4435H13Z"
      fill="white"
    />
  </svg>
);
